import React from "react";
import { FileCard } from "components/RFQ/FileCard";
import { FileUpload } from "components/RFQ/FileUpload";
import LabelForm from "components/RFQ/LabelForm/LabelForm";
import { getMaxFileSizeForReturnableSchedules } from "helpers/fileHelper";
import { FILE_UPLOAD_TYPES, fileUpload } from "newui/components/FileUpload";

export default function ReturnableSchedulesFileUploadComp({
	templateReturnableScheduleFile,
	companyName,
	disabled,
	rfqId,
	rfxInviteId,
	isPreview = false,
}) {
	const maxFileSize = getMaxFileSizeForReturnableSchedules();
	const fileData = {
		name: templateReturnableScheduleFile?.file_name,
		path: templateReturnableScheduleFile?.file_path,
		description: `${companyName} has submitted a returnable schedules template.
		Please download this template and upload your response below.`,
	};

	const onDeleteFile = async (file) => {
		return fileUpload.util.deleteFileUpload(
			file,
			FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_FILE_RESPONSE
		);
	};

	return (
		<>
			<LabelForm label="Download quotation template" />
			<FileCard
				file={fileData}
				isPreview
			/>

			<FileUpload
				type="file"
				label="Attach returnable schedules response"
				name="returnable_schedule_file_responses"
				className="my-4 w-full"
				types={["pdf", "docx", "doc", "mpp", "xlsx", "xls", "csv", "zip"]}
				required
				multiple={true}
				maxFileSize={maxFileSize}
				disabled={disabled}
				hideUploadField={disabled && !isPreview}
				fileExtraData={{
					model: FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_FILE_RESPONSE,
					rfq_id: rfqId,
					rfxInviteId: rfxInviteId,
				}}
				testId="returnable-schedules-file-upload"
				onDelete={onDeleteFile}
			/>
		</>
	);
}
